import { useEffect, useState } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { IMAGES } from "../constants/images";
import { Link } from "react-router-dom";
import { softwareListing } from "api/CategoryService";
const Footer = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await softwareListing(1,5); // Update this function name if different
        if (res.success) {
          setCategories(res.body.data); // Limit to top 5
        }
      } catch (error) {
        console.error("Failed to fetch categories", error);
      }
    };
    fetchCategories();
  }, []);


  return (
    <footer className="footer">
      <Container>
        <Row>
          <Col md={12} lg={4} sm={12} className="mb-3 mb-md-4">
            <div className="footer_about">
              <Image src={IMAGES.Logo} className="logo" alt="" />
              <p>
                Help millions of buyers make better decisions by writing a
                review. Your insights could guide others to their perfect match!
              </p>
              <h3>Follow Us On:</h3>
              <div className="d-flex align-items-center gap-5">
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#fff" }}
                >
                  <Image src={IMAGES.Icon_Social1} alt="" />
                </a>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#fff" }}
                >
                  <Image src={IMAGES.Icon_Social2} alt="" />
                </a>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#fff" }}
                >
                  <Image src={IMAGES.Icon_Social3} alt="" />
                </a>
                <a
                  href="https://skype.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#fff" }}
                >
                  <Image src={IMAGES.Icon_Social4} alt="" />
                </a>
              </div>
            </div>
          </Col>
          <Col md={4} lg={2} sm={6} xs={12} className="mb-3">
            <h5>Quick Links</h5>
            <ul style={{ listStyle: "none", padding: 0 }}>
              <li>
                <Link
                  to="/software"
                  style={{ color: "#fff", textDecoration: "none" }}
                >
                  Software
                </Link>
              </li>
              <li>
                <Link
                  to="/solutions"
                  style={{ color: "#fff", textDecoration: "none" }}
                >
                  Solutions
                </Link>
              </li>
              <li>
                <Link
                  to="/resources"
                  style={{ color: "#fff", textDecoration: "none" }}
                >
                  Resources
                </Link>
              </li>
              <li>
                <Link
                  to="/vendor"
                  style={{ color: "#fff", textDecoration: "none" }}
                >
                  For Vendors
                </Link>
              </li>
              <li>
                <Link
                  to="/about-us"
                  style={{ color: "#fff", textDecoration: "none" }}
                >
                  About Us
                </Link>
              </li>
            </ul>
          </Col>
          <Col md={4} lg={3} sm={6} xs={12} className="mb-3">
            <h5>Top Categories</h5>
            <ul style={{ listStyle: "none", padding: 0 }}>
              {categories.map((cat) => (
                <li key={cat._id}>
                  <Link
                    to={`/software/${cat.slug}`}
                    state={{ resource: cat }}
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    {cat.title}
                  </Link>
                </li>
              ))}
            </ul>
          </Col>
          <Col md={4} lg={3} sm={6} xs={12} className="mb-3">
            <h5>Other</h5>
            <ul style={{ listStyle: "none", padding: 0 }}>
              <li>
                <Link
                  to="/terms-conditions"
                  style={{ color: "#fff", textDecoration: "none" }}
                >
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  style={{ color: "#fff", textDecoration: "none" }}
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/return-policy"
                  style={{ color: "#fff", textDecoration: "none" }}
                >
                  Return Policy
                </Link>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
